<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Rename Analysis</p>
      <button @click="closeModal" type="button" class="close-icon">
        <i class="mdi mdi-close"></i>
      </button>
    </header>
    <section :class="[$style.sectionContainer, 'modal-card-body']">
      <b-field label="New Analysis Name" :class="$style.fieldContainer">
        <b-input v-model="newAnalysisTitle"></b-input>
      </b-field>
    </section>
    <footer class="modal-card-foot">
      <button
        :class="[$style.applyWidth, 'button', 'is-primary', 'is-rounded']"
        @click="saveAnalysis"
        :disabled="!newAnalysisTitle.trim().length"
      >
        Save
      </button>
    </footer>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({ components: {} })
export default class RenameAnalysisModal extends Vue {
  @Prop()
  public currentAnalysisTitle!: string;

  public newAnalysisTitle: string = '';

  public mounted(): void {
    this.newAnalysisTitle = this.currentAnalysisTitle;
  }

  public closeModal(): void {
    this.$emit('close');
  }
  public saveAnalysis(): void {
    this.$emit('updateAnalysisTitle', this.newAnalysisTitle);
    this.$emit('close');
  }
}
</script>
<style module>
.applyWidth {
  width: 83px !important;
}
.sectionContainer {
  padding: 20px 32px 40px 32px;
}
.fieldContainer {
  margin-bottom: unset !important;
}
</style>
